'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

var _reactSlidedown = require('react-slidedown');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var ProgressVerticalIndicator = function (_Component) {
  _inherits(ProgressVerticalIndicator, _Component);

  function ProgressVerticalIndicator(props) {
    _classCallCheck(this, ProgressVerticalIndicator);

    return _possibleConstructorReturn(this, (ProgressVerticalIndicator.__proto__ || Object.getPrototypeOf(ProgressVerticalIndicator)).call(this, props));
  }

  _createClass(ProgressVerticalIndicator, [{
    key: 'onToggleActive',
    value: function onToggleActive() {
      this.props.onToggle && this.props.onToggle(this, !this.props.isActive);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (e.key === "Enter") {
        this.onToggleActive();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          text = _props.text,
          isActive = _props.isActive,
          subIndicators = _props.subIndicators,
          _props$doneIndicators = _props.doneIndicators,
          doneIndicators = _props$doneIndicators === undefined ? [] : _props$doneIndicators;


      var classForIcon = (0, _classnames2.default)("appkiticon", isActive ? "icon-up-chevron-fill" : "icon-down-chevron-fill");

      var parent = _react2.default.createElement(
        _index.KODIV,
        { className: 'a-parent-indicator', tabIndex: 0, onKeyDown: this.onKeyDown.bind(this), onClick: this.onToggleActive.bind(this) },
        _react2.default.createElement(
          'span',
          { className: 'a-indicator-text' },
          ' ',
          text,
          '  '
        ),
        _react2.default.createElement('span', { className: classForIcon })
      );

      var subIndicatorDivs = subIndicators.map(function (e, index) {
        var isDone = doneIndicators.includes(e);
        var subItemCn = (0, _classnames2.default)("a-child-indicator-item", {
          "a-progress-done": isDone
        });
        return _react2.default.createElement(
          'div',
          { key: e + index, className: subItemCn },
          e
        );
      });
      var subCn = (0, _classnames2.default)("a-child-indicator");
      var slidedown = isActive ? _react2.default.createElement(
        _reactSlidedown.SlideDown,
        { transitionOnAppear: false },
        _react2.default.createElement(
          'div',
          { className: subCn },
          subIndicatorDivs
        )
      ) : _react2.default.createElement(_reactSlidedown.SlideDown, { transitionOnAppear: false });

      var cn = (0, _classnames2.default)('a-indicator', className);
      return _react2.default.createElement(
        'div',
        { className: cn },
        parent,
        slidedown
      );
    }
  }]);

  return ProgressVerticalIndicator;
}(_react.Component);

ProgressVerticalIndicator.defaultProps = {
  defaultActive: false,
  doneIndicators: []
};

ProgressVerticalIndicator.propTypes = {
  className: _propTypes2.default.string,
  text: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  onToggle: _propTypes2.default.func,

  defaultActive: _propTypes2.default.bool,
  subIndicators: _propTypes2.default.arrayOf(_propTypes2.default.string),
  doneIndicators: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

ProgressVerticalIndicator.displayName = 'ProgressVerticalIndicator';
exports.default = ProgressVerticalIndicator;